import React, { useContext, createContext } from 'react';
import { useQuery } from 'urql';
import gql from 'graphql-tag';
import { useSupportContext } from '../../../helpers/context-provider';
import { isObjectEmpty } from '../../../utils/is-object-empty';

const ArticleContext = createContext();

export const ArticleProvider = ({ children, data }) => {
  const supportContext = useSupportContext() || {};
  const { isLoading } = supportContext;
  const { strapiArticle, allStrapiArticle, supportcenter = {} } = data || {};
  const [
    { fetching: articleQueryFetching, data: articleQueryData = {}, error: articleQueryError }
  ] = useQuery({
    query: gql`
      query TopicQuery($id: ID!) {
        getSupportData(input: { topicId: $id }) {
          videos
          topics
          groupedArticles {
            subTopicName
            subTopicId
            subTopicOrder
            articles
          }
        }
      }
    `,
    variables: { id: strapiArticle?.uid }
  });

  return (
    <ArticleContext.Provider
      value={{
        user: supportContext,
        strapiArticle,
        allStrapiArticle,
        ...(!isObjectEmpty(articleQueryData) ? articleQueryData : supportcenter),
        isLoading: isLoading || articleQueryFetching
      }}
    >
      {children}
    </ArticleContext.Provider>
  );
};

export const useArticleContext = () => {
  const context = useContext(ArticleContext);
  if (!context || context === undefined)
    throw new Error('useArticleContext must be used within a ArticleProvider');

  return context;
};
